module.exports = __webpack_public_path__ + "img/about_title1.a25641de.png";